import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Form, Nav, NavItem, NavLink, Progress, Row, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import OnBoadingAddress from "../../pages/OnBoarding/components/onBoadingAddress";
import OnBoadingBankID from "../../pages/OnBoarding/components/onBoadingBnakID";
import OnBoadingProduct from "../../pages/OnBoarding/components/onBoadingProduct";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useLocation } from "react-router-dom";

const BuypassAddProduct = (props: any) => {
    const [activeTab, setactiveTab] = useState<number>(1);
    const [progressbarvalue, setprogressbarvalue] = useState<number>(0);
    const [passedSteps, setPassedSteps] = useState<any>([1]);
    const dispatch: any = useDispatch();
    const location = useLocation();
    const initialTab = location.state?.activeTab || 1;

    function toggleTab(tab: any, value: any) {
        if (activeTab !== tab) {
            var modifiedSteps = [...passedSteps, tab];
            if (tab >= 1 && tab <= 3) { // Restricting tabs to 1, 2, and 3 only
                setactiveTab(tab);
                setPassedSteps(modifiedSteps);
            }
        }
        setprogressbarvalue(value);
    }

    const handleNext = () => {
        if (activeTab < 3) {
            toggleTab(activeTab + 1, (activeTab + 1) * 33);
        }
    };

    const handleBack = () => {
        if (activeTab > 1) {
            toggleTab(activeTab - 1, (activeTab - 1) * 33);
        }
    };

    useEffect(() => {
        if (location.state?.activeTab) {
            setactiveTab(location.state.activeTab);
        }
    }, [location.state]);

    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );

    const user = useSelector(selectUser);

    useEffect(() => {
    }, [user]);

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="On Boarding" pageTitle="OnBoarding" pageTitleRoute="/on-boarding" />
                <Row>
                    <Col xl={12} className="bg-success rounded-top-3 ">
                        <h3 className="f-bolder mb-3 mt-3 text-light">To Do</h3>
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="progress-nav mb-5 w-75">
                                <Progress value={progressbarvalue} style={{ height: "1px" }} />
                                <Nav className="nav-pills progress-bar-tab custom-nav" role="tablist">
                                    <NavItem className="CustomClassDv">
                                        <NavLink
                                            to="#"
                                            id="pills-address-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 1,
                                                    done: activeTab >= 1,
                                                },
                                                "rounded-pill infonewDv"
                                            )}
                                            onClick={() => toggleTab(1, 0)}
                                            tag="button"
                                        >
                                            <div className="p-0 w-100 h-100 d-flex justify-content-center align-items-center">
                                                {user?.storeStatus?.isAddressAdded ? (
                                                    <i className="ri-check-line fs-3"></i>
                                                ) : (
                                                    <span className="d-flex justify-content-center align-items-center">1</span>
                                                )}
                                            </div>
                                            <div className="mt-1">
                                                <h6 className="m-0 text-light">Address</h6>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className="CustomClassDv">
                                        <NavLink
                                            to="#"
                                            id="pills-bank-id-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 2,
                                                    done: activeTab >= 2,
                                                },
                                                "rounded-pill infonewDv"
                                            )}
                                            onClick={() => toggleTab(2, 50)}
                                            tag="button"
                                        >
                                            <div className="p-0 w-100 h-100 d-flex justify-content-center align-items-center">
                                                {user?.storeStatus?.isIdBankDetails ? (
                                                    <i className="ri-check-line fs-3"></i>
                                                ) : (
                                                    <span className="d-flex justify-content-center align-items-center">2</span>
                                                )}
                                            </div>
                                            <div className="mt-1">
                                                <h6 className="m-0 text-light">Bank ID</h6>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className="CustomClassDv">
                                        <NavLink
                                            to="#"
                                            id="pills-product-tab"
                                            className={classnames(
                                                {
                                                    active: activeTab === 3,
                                                    done: activeTab >= 3,
                                                },
                                                "rounded-pill infonewDv"
                                            )}
                                            onClick={() => toggleTab(3, 100)}
                                            tag="button"
                                        >
                                            <div className="p-0 w-100 h-100 d-flex justify-content-center align-items-center">
                                                {user?.storeStatus?.isProductAdded ? (
                                                    <i className="ri-check-line fs-3"></i>
                                                ) : (
                                                    <span className="d-flex justify-content-center align-items-center">3</span>
                                                )}
                                            </div>
                                            <div className="mt-1">
                                                <h6 className="m-0 text-light">Product</h6>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                        </div>
                        <Card>
                            <CardHeader>
                                <div className="d-flex justify-content-between">
                                    {activeTab !== 1 && (
                                        <Button
                                            color="secondary"
                                            onClick={handleBack}
                                            className="me-auto"
                                            disabled={activeTab === 1}
                                            style={{ marginRight: "10px" }}
                                        >
                                            Back
                                        </Button>
                                    )}
                                    {activeTab !== 3 && (
                                        <Button
                                            color="primary"
                                            onClick={handleNext}
                                            className="ms-auto"
                                            style={{ marginLeft: "10px" }}
                                        >
                                            Next
                                        </Button>
                                    )}
                                </div>
                            </CardHeader>
                            <CardBody className="form-steps">
                                <Form action="#">
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId={1}>
                                            <Form onSubmit={(e) => e.preventDefault()}>
                                                <OnBoadingAddress />
                                            </Form>
                                        </TabPane>
                                        <TabPane tabId={2}>
                                            <Form onSubmit={(e) => e.preventDefault()}>
                                                <OnBoadingBankID />
                                            </Form>
                                        </TabPane>
                                        <TabPane tabId={3}>
                                            <Form onSubmit={(e) => e.preventDefault()}>
                                                <OnBoadingProduct />
                                            </Form>
                                        </TabPane>
                                    </TabContent>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default BuypassAddProduct;
